import React from 'react';

const Restaurante = () => {
  return (
<div className="container mt-5 pt-3">
{/* Section 1: Bootstrap Carousel */}
<div id="granjaCarousel" className="carousel slide mb-5" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
    <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="4" aria-label="Slide 5"></button>
    <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="5" aria-label="Slide 6"></button>
    <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="6" aria-label="Slide 7"></button>
  </div>
  
  <div className="carousel-inner rounded shadow">
    <div className="carousel-item active">
      <img src="/comida.JPG" className="d-block w-100" alt="Animales de granja" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
    </div>
    <div className="carousel-item">
      <img src="/comida2.JPG" className="d-block w-100" alt="Vacas y terneros" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
    </div>
    <div className="carousel-item">
      <img src="/comida3.jpeg" className="d-block w-100" alt="Ovejas y corderos" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
    </div>
    <div className="carousel-item">
      <img src="/comida4.JPG" className="d-block w-100" alt="Ovejas y corderos" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
    </div>
    <div className="carousel-item">
      <img src="/comida5.JPG" className="d-block w-100" alt="Ovejas y corderos" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
    </div>
    <div className="carousel-item">
      <img src="/comida6.JPG" className="d-block w-100" alt="Ovejas y corderos" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
    </div>
    <div className="carousel-item">
      <img src="/comida7.JPG" className="d-block w-100" alt="Ovejas y corderos" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
    </div>
  </div>
  
  <button className="carousel-control-prev" type="button" data-bs-target="#granjaCarousel" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#granjaCarousel" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>

{/* Section 2: Title and Description */}
<div className="row">
  <div className="col-12 text-center">
    <h1 className="display-4 text-success mb-3">RESTAURANTE</h1>
    <p className="lead mb-5">Deleita tu paladar con el sabor de nuestra comida típica cartagenera.</p>
  </div>
</div>

{/* Section 3: Information and Recommendations */}
<div className="row mb-5">
  <div className="col-md-8 mx-auto text-center">
    <h2 className="mb-4 text-success">Información importante</h2>
    
    <div className="mb-4">
      <h4>Horario:</h4>
      <p className="fs-5">Desayuno: 7 am – 10 am</p>
      <p className="fs-5">Almuerzo: 1 pm – 3 pm</p>
      <p className="fs-5">Cena: 6 pm – 8 pm</p>
    </div>
  </div>
</div>
</div>
  );
};

export default Restaurante;
